import { HttpStatusCode } from "axios";
import dayjs from "dayjs";
import { AppointmentType } from "../../../components/modals/bookingModalComponents/context/BookingModalContext";
import { ERROR } from "../../../enums/AlertTypes";
import { BOOKED_TIME } from "../../../enums/ApiPaths";
import { STATUSES } from "../../../enums/AppointmentStatus";
import useServiceTranslation from "../../../hooks/useServiceTranslation";
import { getDateObject } from "../../../utils/DateTimeRepository";
import { getBearerToken } from "../../../utils/Functions";
import { normalizePetGender } from "../../pets/utils/Functions";
import authApi from "../../../utils/api/authApi";
// Check if any of these methods are used and if not delete

function renderCondition(bookings) {
  return bookings.length < 1;
}

export function useGetCalendarData(data) {
  var name = useServiceTranslation(data?.priceList);
  return parseCalendarAppointements(data, name);
}

function parseCalendarAppointements(booking, service) {
  if (booking.startDate !== null && booking.status !== STATUSES.INACTIVE) {
    return {
      id: booking.id,
      title: booking.pet ? booking?.pet?.name + " " + service : service,
      start: dayjs(getDateObject(booking?.startDate)).$d,
      end: dayjs(getDateObject(booking?.endDate)).$d,
      type: service,
    };
  }
}

Date.prototype.yyyymmdd = function () {
  var mm = this.getMonth() + 1; // getMonth() is zero-based
  var dd = this.getDate();
  return [
    (dd > 9 ? "" : "0") + dd,
    (mm > 9 ? "" : "0") + mm,
    this.getFullYear(),
  ].join("/");
};

Date.prototype.ddmmyyyHHmm = function () {
  var time = this.toLocaleString("it-IT");
  return [time].join(" ");
};

const executeHandleDateChange = async (
  date,
  setAvailableHours,
  setUserSelectedDate,
  handleSnackbar,
  currentClinicId
) => {
  try {
    const header = await getBearerToken();
    let res = await authApi.get(
      BOOKED_TIME +
        currentClinicId +
        "?date=" +
        dayjs(date).format("DD/MM/YYYY"),
      {
        headers: header,
      }
    );
    if (res.status == HttpStatusCode.Ok) {
      setAvailableHours(res.data);
      setUserSelectedDate(date);
    }
  } catch (e) {
    handleSnackbar(e?.response?.data, ERROR);
  } finally {
  }
};

//Add length of appointment service check (can't be more than 120)
//Add time check (times can't be the same)
//Handle these errors in their respsected components not in the method
function getAppointmentObject(
  submitObject,
  isAdminOrEmployee,
  loggedInUserEmail,
  isBasic
) {
  const isUserAdmin = isAdminOrEmployee;
  const appointement = submitObject;
  const startTime = appointement?.time + ":00";
  const endTime = appointement?.endTime + ":00";
  
  if (appointement.email == null) {
    appointement.email = loggedInUserEmail;
  }

  const new_obj = {
    ...appointement,
    status: isUserAdmin ? STATUSES.ACTIVE : STATUSES.WAITING_CLINIC,
    startDate: appointement?.startDate.format("DD/MM/YYYY") + ", " + startTime,
    priceList: appointement[AppointmentType],
  };

  if (isAdminOrEmployee && appointement?.pet == "") {
    delete appointement?.pet;
  }

  if (appointement?.pet != null && appointement?.pet != undefined) {
    if (typeof appointement?.pet == "number") {
      new_obj.pet = {
        id: appointement.pet,
      };
    } else {
      new_obj.pet = {
        ...appointement.pet,
        birthdate: getPetBirthDate(appointement.pet.birthdate),
        gender: normalizePetGender(appointement.pet.gender),
        breed: appointement?.pet.breed,
        microchip: appointement?.microchip,
        passport: appointement?.passport,
      };
    }
  }

  if (isUserAdmin) {
    if (appointement.endTime) {
      new_obj.endDate =
        appointement?.startDate.format("DD/MM/YYYY") + ", " + endTime;
    }
  }
  //This might not be needed anymore, we used this for the old timepickers
  return checkTimes(new_obj);
}
function checkTimes(obj) {
  delete obj.time;
  delete obj.endTime;
  return obj;
}

function getPetBirthDate(birthdate) {
  if (birthdate == null) return "";
  else if (typeof birthdate === "object") return birthdate.format("DD/MM/YYYY");
  else return birthdate;
}

export {
  executeHandleDateChange,
  getAppointmentObject,
  parseCalendarAppointements,
  renderCondition,
};
